module.exports = __webpack_public_path__ + "static/img/deer.c41cda5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/deer.jpg
// module id = 109
// module chunks = 0